<div class="spot-component-view">
  <mat-card class="item">
    <mat-card-header>
      <mat-card-title>Yard Spot: {{ selectedYard.location }}</mat-card-title>
    </mat-card-header>
    <mat-card-content class="item-view" [ngSwitch]="viewMode">
      <section *ngSwitchCase="'view'" class="spot-view">
        <div class="spot-data">
        

          <h4>Location status</h4>
          <p>{{ selectedYard?.status ?? "No data" }}</p>

          <h3>Trailer info</h3>

          <h4>PO</h4>
          <p>{{ selectedYard?.trailer?.po ?? "No data"}}</p>

          <h4><strong>Trailer Number: </strong></h4>
          <p>{{ selectedYard?.trailer?.trailer_number ?? "No data" }}</p>

          <h4><strong>Carrier: </strong></h4>
          <p>{{ selectedYard?.trailer?.carrier ?? "No data" }}</p>

          <h4><strong>Status: </strong></h4>
          <p>{{ selectedYard?.trailer?.status ?? "No data" }}</p>
        </div>

        <div class="view-btn-container" *ngIf="!confirmDeleteMode">
          <button
            mat-fab
            color="warn"
            (click)="enterDeleteMode()"
            matTooltip="Checkout"
            [disabled]="selectedYard.status !== 'occupied'"
          >
            <mat-icon>delete</mat-icon>
          </button>

          <button
            mat-fab
            color="primary"
            (click)="enterAddMode()"
            matTooltip="Add trailer"
            [disabled]="selectedYard.status !== 'empty'"
          >
            <mat-icon>add</mat-icon>
          </button>
          <button
          mat-fab
          color="accent"
          (click)="enterEditMode()"
          matTooltip="Edit"
          [disabled]="selectedYard.status !== 'occupied'"
        >
          <mat-icon>edit</mat-icon>
        </button>
        </div>
        <div class="view-btn-container" *ngIf="confirmDeleteMode">
          <button
            mat-fab
            color="warn"
            (click)="checkOutTrailer()"
            matTooltip="Confirm Checkout"
          >
            <mat-icon>remove_circle</mat-icon>
          </button>
          <button
            mat-fab
            color="primary"
            (click)="enterDeleteMode()"
            matTooltip="Undo"
          >
            <mat-icon>undo</mat-icon>
          </button>
        </div>
      </section>
      <section *ngSwitchCase="'add'" class="spot-form">
        <form #spotForm="ngForm">
          <div class="form-data">
            <mat-form-field appearance="fill">
              <mat-select [(ngModel)]="selectedTrailer" name="trailer" (selectionChange)="onTrailerSelectionChange($event)">
                <mat-option
                  *ngFor="let trailer of availableTrailers"
                  [value]="trailer"
                >
                  {{ trailer.trailer_number }}
                </mat-option>
              </mat-select>
            </mat-form-field>


          <h4>PO</h4>
          <p>{{ updatedTrailer?.po ?? "No data"}}</p>

          <h4><strong>Trailer Number: </strong></h4>
          <p>{{ updatedTrailer?.trailer_number ?? "No data" }}</p>
      
          <h4><strong>Carrier: </strong></h4>
          <p>{{ updatedTrailer?.carrier ?? "No data" }}</p>


          <ng-container *ngIf="selectedTrailer">
            <mat-form-field appearance="fill">
              <mat-label>Status</mat-label>
              <mat-select name="status" [(ngModel)]="updatedTrailer.status">
                <mat-option *ngFor="let status of trailerStatus" [value]="status">
                  {{ status }}
                </mat-option>
              </mat-select>  
            </mat-form-field>
          </ng-container>
    
          </div>
          <div class="form-btn-container">
            <button mat-fab color="primary" type="button" [disabled]="!updatedTrailer" (click)="assignTrailer()">
              <mat-icon>check</mat-icon>
            </button>
            <button mat-fab color="warn" type="button" (click)="enterViewMode()">
              <mat-icon>undo</mat-icon>
            </button>
        
          </div>
        </form>
      </section>
      <section *ngSwitchCase="'edit'" class="spot-form">
        <form #spotForm="ngForm">
          <div class="form-data">
            <mat-form-field appearance="fill">
              <mat-label>PO#</mat-label>
              <input matInput [(ngModel)]="updatedTrailer.po" type="text" name="po">
            </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>Trailer Number</mat-label>
            <input matInput [(ngModel)]="updatedTrailer.trailer_number" type="text" name="trailer">
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>Carrier</mat-label>
            <input matInput [(ngModel)]="updatedTrailer.carrier" type="text" name="carrier">
          </mat-form-field>
          <mat-form-field appearance="fill">
            
            <mat-label>Status</mat-label>
            <mat-select name="status" [(ngModel)]="updatedTrailer.status">
              <mat-option *ngFor="let status of trailerStatus" [value]="status">
                {{ status }}
              </mat-option>
            </mat-select>  
          </mat-form-field>
          </div>
        </form>
        <div class="form-btn-container">
          <button mat-fab color="primary" matTooltip="Save changes" (click)="updateTrailerData()">
            <mat-icon>check</mat-icon>
          </button>
          <button mat-fab color="warn" matTooltip="Exit" (click)="exitEditMode()">
            <mat-icon>undo</mat-icon>
          </button>
          </div>
      </section>
    </mat-card-content>
  </mat-card>
</div>
